<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;padding-top:5px !important">
	<el-tabs v-model="activeName" @tab-click="handleClick" type="border-card" class="mt-2">
      
      
       <el-tab-pane  name="tab1">
           <span slot="label"><i class="el-icon-user-solid"></i>{{$t('nav.마스터관리')}}</span>
          <div class="d-flex align-items-center">
    
    <div class="">
      <el-form inline ref="form" :model="searchform">

      

          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value" :placeholder="$t('status.선택')" size="mini" style="width:120px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
            <template>
              <el-autocomplete v-model="searchform.keyword" :placeholder="$t('searchText.키워드')" :fetch-suggestions="querySearchAsync" :trigger-on-focus="false" @select="handleSelect"  style="width:150px"  size="mini" ></el-autocomplete>
              
            </template>
            <!--<template v-if="this.searchform.value == 'mem_id'">
               <el-autocomplete :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:150px"  :fetch-suggestions="querySearchAsync" @select="handleSelect"></el-autocomplete>
            </template>-->
            
          </el-form-item>
         
          <el-form-item  class="mb-0 mr-0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                  :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini"  value-format="yyyy-MM-dd" style="width:200px" >
                </el-date-picker>
          </el-form-item>
          
          
            <el-form-item  class="mb-0">
            <span class="text-muted mr-2" style="margin-top: -6px; ">{{$t('msg.오늘접속')}}</span><el-checkbox true-label="1" false-label="0" v-model="searchform.online" style="vertical-align: middle;margin-right:10px"></el-checkbox> 
             <span class="text-muted mr-2" style="margin-top: -6px;">{{$t('msg.하부포함')}}</span><el-checkbox true-label="1" false-label="0" v-model="habu" style="vertical-align: middle;"></el-checkbox>
          </el-form-item>
          
          <el-form-item class="mb-0">
            <el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button> 
          <!--  <el-button type="success" size="mini" icon="el-icon-document-delete" @click="exportExcel" :disabled = "disabled">{{$t('searchText.엑셀다운')}}</el-button> -->
          </el-form-item>
           <el-form-item class="mb-0 mr-0">
           <!--<el-button type="primary" size="mini" @click="openUserModel(false)" class="mb-2">{{$t('searchText.회원생성')}}</el-button> --> 
          <!--<el-button type="primary"  size="mini"  @click="bonOpen(1,'','1')">{{$t('searchText.머니충환전')}}</el-button> --> 
          </el-form-item>
      </el-form>
       
    
    </div>
  
  </div>
  

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
     :span-method="objectSpanMethod"
      :cell-class-name="addClass"

      :header-cell-style="headerStyleEvent"
      :row-class-name="tableRowClassName"
       border
        class="mt-2 memlistTable memH"
        :empty-text="$t('tableText.데이타가없습니다')" @sort-change='tableSortChange'  @row-click="rowClick"  >
    
     <el-table-column width="50" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{(total*2-(currentPage-1)*size*2-scope.$index)/2}}</template>
        </el-table-column>
<el-table-column width="100" align="center"  :label="$t('newAdd.상부')" prop="dire">
 <template slot-scope="scope">
   <span @click="haha(scope.row.dire,scope.row.level)" style="color:#337ab7">{{scope.row.dire}}</span>
          </template>
        </el-table-column>
          <el-table-column label=""   align="center" width="45">

            <template slot-scope="scope">

              <span @click="haha(scope.row.mem_id,'m_code')" v-if="scope.row.mem_id==scope.row.m_code" class="bg-success text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px;background:#3e3e3e !important">MST</span>
              <span @click="haha(scope.row.mem_id,'s_code')" v-if="scope.row.mem_id==scope.row.s_code" class="bg-success text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px;background:#e54747 !important">{{$t('msg.본사')}}</span>
           <span @click="haha(scope.row.mem_id,'b_code')"  v-if="scope.row.mem_id==scope.row.b_code" class="bg-success text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px">{{$t('msg.부본')}}</span>
            <span @click="haha(scope.row.mem_id,'a_code')"  v-if="scope.row.mem_id==scope.row.a_code" class="bg-primary text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px">{{$t('msg.총판')}}</span>
            <span @click="haha(scope.row.mem_id,'c_code')"  v-if="scope.row.mem_id==scope.row.c_code " class="bg-warning text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px">{{$t('msg.매장')}}</span>
             <span  @click="haha(scope.row.mem_id,'m_cp')" v-if="scope.row.mem_id!=scope.row.a_code && scope.row.mem_id!=scope.row.b_code && scope.row.mem_id!=scope.row.c_code && scope.row.mem_id!=scope.row.s_code && scope.row.mem_id!=scope.row.m_code" class="bg-info text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px">{{$t('msg.유저')}}</span>
           </template>
        </el-table-column>

        <el-table-column v-if="this.sitetype=='4'" :label="$t('nav.아이디')"  prop="mem_id" align="center" width="170">
          <template slot-scope="scope">
            <div :style="{ backgroundColor :scope.row.RaceYN}">
            <span :class="scope.row.mem_status === '0' || scope.row.memState === '-2' ?'text-danger':''" @click="openModel(scope.row.mem_id,'tab1')" style="cursor:pointer">{{ scope.row.mem_id}}</span><span v-if="scope.row.mem_status === '0'" class="text-danger">(탈퇴)</span><br>(<span @click="openModel(scope.row.mem_id,'tab1')"  style="cursor:pointer">{{ scope.row.mem_name}}</span>)<span class="bg-danger ml-1 text-white px-1 py-1" style="border-radius:5px;" v-if="scope.row.add_time && scope.row.add_time>= logintime" @click="onTips">on</span>
          </div></template>
        </el-table-column>

     
        

   

        


    

        

        <template v-if="this.aid=='soft10' && this.sim!='1' " >

            <el-table-column :label="$t('msg.알잔액')"  prop="mem_cash" sortable="custom" align="center">
          <template slot-scope="scope"><span class="text-primary" @click="bonOpen(1,scope.row.mem_id,'1')"  style="cursor:pointer">{{ formatMoney(scope.row.mem_cash)}}</span></template>
        </el-table-column>

          <el-table-column :label="$t('msg.카슬머니')" prop="api_money" sortable="custom" align="center">
          <template slot-scope="scope"><span class="text-primary" @click="bonOpen(6,scope.row.mem_id,'1')"  style="cursor:pointer">{{ formatMoney(scope.row.api_money)}}</span></template>
        </el-table-column>

        <el-table-column :label="$t('msg.카슬롤링')" prop="mem_eventmoney" sortable="custom" align="center">
          <template slot-scope="scope"><span class="text-primary" @click="bonOpen(2,scope.row.mem_id,'1')"  style="cursor:pointer">{{ formatMoney(scope.row.mem_eventmoney)}}</span></template>
        </el-table-column>
         
   

        </template>

      

        <el-table-column  :label="$t('tableText.타입')"  prop="ca_title" align="center">
        
        </el-table-column>
        <el-table-column  :label="$t('msg.베팅')"  prop="ca_bet" align="center" sortable="custom">
         <template slot-scope="scope">
          <span :class="func(scope.row.ca_bet) " style="font-weight:bold"> {{ formatMoney(scope.row.ca_bet)}}</span>
         </template>
        </el-table-column>
       
        <el-table-column  :label="$t('msg.당첨')"  prop="ca_win" align="center" sortable="custom">
         <template slot-scope="scope">
           <span :class="func(scope.row.ca_win)"  style="font-weight:bold"> {{ formatMoney(scope.row.ca_win)}}</span>
         </template>
        </el-table-column>
          <el-table-column  :label="$t('newAdd.수수료')"  prop="ca_rog" align="center" sortable="custom">
         <template slot-scope="scope">
           <span :class="func(scope.row.ca_rog)" style="font-weight:bold"> {{ formatMoney(scope.row.ca_rog)}}</span>
         </template>
        </el-table-column>

        <el-table-column  :label="$t('newAdd.손익')"  prop="ca_tt" align="center" sortable="custom">
         <template slot-scope="scope">
           <span :class="func(scope.row.ca_tt)"  style="font-weight:bold"> {{ formatMoney(scope.row.ca_tt)}}</span>
         </template>
        </el-table-column>
      
        <el-table-column  :label="$t('newAdd.최종손익')"  prop="ca_total" align="center" sortable="custom">
         <template slot-scope="scope">
            <span :class="func(scope.row.ca_total)" style="font-weight:bold">{{ formatMoney(scope.row.ca_total)}}</span>
         </template>
        </el-table-column>


      

       

        <el-table-column v-if="this.sitetype==='2'"  :label="$t('msg.마지막입금')" width="115" sortable="custom" prop="last_money_date" align="center">
          <template slot-scope="scope">{{ scope.row.last_money_date ? scope.row.last_money_date.substring(0,10):""}}</template>
        </el-table-column>
         

     <!--    <el-table-column
           align="center"
          prop="memState"
          :label="$t('msg.등급')"
          >
          <template slot-scope="scope">
          <el-select :placeholder="$t('status.선택')" v-model="scope.row.memState" size="mini" style="width:80px" @change="changeOptions(scope)">
              <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
            </el-select>
      </template>
          </el-table-column>
         <el-table-column :label="$t('status.편집')" prop="mem_regdate" align="center">
         <template slot-scope="scope">
        
           <el-button-group>
                <el-button type="primary" icon="el-icon-edit" size="mini" @click="openModel(scope.row.mem_id)"></el-button>
                <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteAll(scope)"></el-button>
           </el-button-group>
        
      </template>
        </el-table-column> -->
         <el-table-column :label="$t('newAdd.설정')" width="260" align="center" class="mybuttonmini">
         <template slot-scope="scope">
        
           
                <el-button type="success" icon="el-icon-error" size="mini"  @click="openModel(scope.row.mem_id,'tab4')">{{$t('tableText.내손익')}}</el-button>
               <el-button type="success" icon="el-icon-error" size="mini"  @click="openModel(scope.row.mem_id,'tab48')">{{$t('newAdd.월정산')}}</el-button>
               <el-button type="warning" icon="el-icon-edit" size="mini"  @click="openModel(scope.row.mem_id,'tab3')">{{$t('searchText.요율')}}</el-button>
                <el-button type="danger" v-if="scope.row.is_add" icon="el-icon-circle-plus" size="mini" @click="userAdd(scope.row.mem_id,scope.row.gubun,scope.row.event_loing_e,scope.row.event_loing_slot,scope.row.event_loing_recom_e,scope.row.event_loing_recom_slot)">{{$t('tableText.추가')}}</el-button>
                 <el-tooltip class="item" effect="dark" content="요율없음 하부생성불가" placement="top"> 
                <el-button type="info" v-if="scope.row.is_add==0" icon="el-icon-circle-plus" size="mini" >{{$t('tableText.추가')}}</el-button> 
              </el-tooltip>
        
      </template>
        </el-table-column>
    
      
  
     
    </el-table>
        </el-tab-pane>
         <el-tab-pane  name="tab2">
           <span slot="label"><i class="el-icon-user-solid"></i>{{$t('nav.본사관리')}}</span>
          <div class="d-flex align-items-center">
    
    <div class="">
      <el-form inline ref="form" :model="searchform">

      

          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value" :placeholder="$t('status.선택')" size="mini" style="width:120px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
            <template>
              <el-autocomplete v-model="searchform.keyword" :placeholder="$t('searchText.키워드')" :fetch-suggestions="querySearchAsync" :trigger-on-focus="false" @select="handleSelect"  style="width:150px"  size="mini" ></el-autocomplete>
              
            </template>
            <!--<template v-if="this.searchform.value == 'mem_id'">
               <el-autocomplete :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:150px"  :fetch-suggestions="querySearchAsync" @select="handleSelect"></el-autocomplete>
            </template>-->
            
          </el-form-item>
         
          <el-form-item  class="mb-0 mr-0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                  :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini"  value-format="yyyy-MM-dd" style="width:200px" >
                </el-date-picker>
          </el-form-item>
          
          
            <el-form-item  class="mb-0">
            <span class="text-muted mr-2" style="margin-top: -6px;">{{$t('msg.오늘접속')}}</span><el-checkbox true-label="1" false-label="0" v-model="searchform.online" style="vertical-align: middle;"></el-checkbox>
             <span class="text-muted mr-2" style="margin-top: -6px;">{{$t('msg.하부포함')}}</span><el-checkbox true-label="1" false-label="0" v-model="habu" style="vertical-align: middle;"></el-checkbox>
          </el-form-item>
          
          <el-form-item class="mb-0">
            <el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button> 
          <!--  <el-button type="success" size="mini" icon="el-icon-document-delete" @click="exportExcel" :disabled = "disabled">{{$t('searchText.엑셀다운')}}</el-button> -->
          </el-form-item>
           <el-form-item class="mb-0 mr-0">
           <el-button type="primary" size="mini" @click="openUserModel(false)" class="mb-2">{{$t('searchText.회원생성')}}</el-button>
          <!--<el-button type="primary"  size="mini"  @click="bonOpen(1,'','1')">{{$t('searchText.머니충환전')}}</el-button> --> 
          </el-form-item>
      </el-form>
       
    
    </div>
  
  </div>
  

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
     :span-method="objectSpanMethod"
      :cell-class-name="addClass"

      :header-cell-style="headerStyleEvent"
      :row-class-name="tableRowClassName"
       border
        class="mt-2 memlistTable memH"
        :empty-text="$t('tableText.데이타가없습니다')" @sort-change='tableSortChange'  @row-click="rowClick"  >
    
     <el-table-column width="50" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{(total*2-(currentPage-1)*size*2-scope.$index)/2}}</template>
        </el-table-column>
<el-table-column width="100" align="center"  :label="$t('newAdd.상부')" prop="dire">
 <template slot-scope="scope">
   <span @click="haha(scope.row.dire,scope.row.level)" style="color:#337ab7">{{scope.row.dire}}</span>
          </template>
        </el-table-column>
          <el-table-column label=""   align="center" width="45">

            <template slot-scope="scope">

              <span @click="haha(scope.row.mem_id,'m_code')" v-if="scope.row.mem_id==scope.row.m_code" class="bg-success text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px;background:#3e3e3e !important">MST</span>
              <span @click="haha(scope.row.mem_id,'s_code')" v-if="scope.row.mem_id==scope.row.s_code" class="bg-success text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px;background:#e54747 !important">{{$t('msg.본사')}}</span>
           <span @click="haha(scope.row.mem_id,'b_code')"  v-if="scope.row.mem_id==scope.row.b_code" class="bg-success text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px">{{$t('msg.부본')}}</span>
            <span @click="haha(scope.row.mem_id,'a_code')"  v-if="scope.row.mem_id==scope.row.a_code" class="bg-primary text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px">{{$t('msg.총판')}}</span>
            <span @click="haha(scope.row.mem_id,'c_code')"  v-if="scope.row.mem_id==scope.row.c_code " class="bg-warning text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px">{{$t('msg.매장')}}</span>
             <span  @click="haha(scope.row.mem_id,'m_cp')" v-if="scope.row.mem_id!=scope.row.a_code && scope.row.mem_id!=scope.row.b_code && scope.row.mem_id!=scope.row.c_code && scope.row.mem_id!=scope.row.s_code && scope.row.mem_id!=scope.row.m_code" class="bg-info text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px">{{$t('msg.유저')}}</span>
           </template>
        </el-table-column>

        <el-table-column v-if="this.sitetype=='4'" :label="$t('nav.아이디')"  prop="mem_id" align="center" width="170">
          <template slot-scope="scope">
            <div :style="{ backgroundColor :scope.row.RaceYN}">
            <span :class="scope.row.mem_status === '0' || scope.row.memState === '-2' ?'text-danger':''" @click="openModel(scope.row.mem_id,'tab1')" style="cursor:pointer">{{ scope.row.mem_id}}</span><span v-if="scope.row.mem_status === '0'" class="text-danger">(탈퇴)</span><br>(<span @click="openModel(scope.row.mem_id,'tab1')"  style="cursor:pointer">{{ scope.row.mem_name}}</span>) <el-tag type="success">V{{scope.row.memState}}</el-tag><span class="bg-danger ml-1 text-white px-1 py-1" style="border-radius:5px;" v-if="scope.row.add_time && scope.row.add_time>= logintime" @click="onTips">on</span>
          </div></template>
        </el-table-column>

     
        

   

        


    

        

        <template v-if="this.aid=='soft10' && this.sim!='1' " >

            <el-table-column :label="$t('msg.알잔액')"  prop="mem_cash" sortable="custom" align="center">
          <template slot-scope="scope"><span class="text-primary" @click="bonOpen(1,scope.row.mem_id,'1')"  style="cursor:pointer">{{ formatMoney(scope.row.mem_cash)}}</span></template>
        </el-table-column>

          <el-table-column :label="$t('msg.카슬머니')" prop="api_money" sortable="custom" align="center">
          <template slot-scope="scope"><span class="text-primary" @click="bonOpen(6,scope.row.mem_id,'1')"  style="cursor:pointer">{{ formatMoney(scope.row.api_money)}}</span></template>
        </el-table-column>

        <el-table-column :label="$t('msg.카슬롤링')" prop="mem_eventmoney" sortable="custom" align="center">
          <template slot-scope="scope"><span class="text-primary" @click="bonOpen(2,scope.row.mem_id,'1')"  style="cursor:pointer">{{ formatMoney(scope.row.mem_eventmoney)}}</span></template>
        </el-table-column>
         
   

        </template>

      

        <el-table-column  :label="$t('tableText.타입')"  prop="ca_title" align="center">
        
        </el-table-column>
        <el-table-column  :label="$t('msg.베팅')"  prop="ca_bet" align="center" sortable="custom">
         <template slot-scope="scope">
          <span :class="func(scope.row.ca_bet) " style="font-weight:bold"> {{ formatMoney(scope.row.ca_bet)}}</span>
         </template>
        </el-table-column>
       
        <el-table-column  :label="$t('msg.당첨')"  prop="ca_win" align="center" sortable="custom">
         <template slot-scope="scope">
           <span :class="func(scope.row.ca_win)"  style="font-weight:bold"> {{ formatMoney(scope.row.ca_win)}}</span>
         </template>
        </el-table-column>
          <el-table-column  :label="$t('newAdd.수수료')"  prop="ca_rog" align="center" sortable="custom">
         <template slot-scope="scope">
           <span :class="func(scope.row.ca_rog)" style="font-weight:bold"> {{ formatMoney(scope.row.ca_rog)}}</span>
         </template>
        </el-table-column>

        <el-table-column  :label="$t('newAdd.손익')"  prop="ca_tt" align="center" sortable="custom">
         <template slot-scope="scope">
           <span :class="func(scope.row.ca_tt)"  style="font-weight:bold"> {{ formatMoney(scope.row.ca_tt)}}</span>
         </template>
        </el-table-column>
      
        <el-table-column  :label="$t('newAdd.최종손익')"  prop="ca_total" align="center" sortable="custom">
         <template slot-scope="scope">
            <span :class="func(scope.row.ca_total)" style="font-weight:bold">{{ formatMoney(scope.row.ca_total)}}</span>
         </template>
        </el-table-column>


      

       

        <el-table-column v-if="this.sitetype==='2'"  :label="$t('msg.마지막입금')" width="115" sortable="custom" prop="last_money_date" align="center">
          <template slot-scope="scope">{{ scope.row.last_money_date ? scope.row.last_money_date.substring(0,10):""}}</template>
        </el-table-column>
         

     <!--    <el-table-column
           align="center"
          prop="memState"
          :label="$t('msg.등급')"
          >
          <template slot-scope="scope">
          <el-select :placeholder="$t('status.선택')" v-model="scope.row.memState" size="mini" style="width:80px" @change="changeOptions(scope)">
              <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
            </el-select>
      </template>
          </el-table-column>
         <el-table-column :label="$t('status.편집')" prop="mem_regdate" align="center">
         <template slot-scope="scope">
        
           <el-button-group>
                <el-button type="primary" icon="el-icon-edit" size="mini" @click="openModel(scope.row.mem_id)"></el-button>
                <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteAll(scope)"></el-button>
           </el-button-group>
        
      </template>
        </el-table-column> -->
         <el-table-column :label="$t('newAdd.설정')" width="260" align="center" class="mybuttonmini">
         <template slot-scope="scope">
        
           
                <el-button type="success" icon="el-icon-error" size="mini"  @click="openModel(scope.row.mem_id,'tab4')">{{$t('tableText.내손익')}}</el-button>
               <el-button type="success" icon="el-icon-error" size="mini"  @click="openModel(scope.row.mem_id,'tab48')">{{$t('newAdd.월정산')}}</el-button>
               <el-button type="warning" icon="el-icon-edit" size="mini"  @click="openModel(scope.row.mem_id,'tab3')">{{$t('searchText.요율')}}</el-button>
                <el-button type="danger" v-if="scope.row.is_add" icon="el-icon-circle-plus" size="mini" @click="userAdd(scope.row.mem_id,scope.row.gubun,scope.row.event_loing_e,scope.row.event_loing_slot,scope.row.event_loing_recom_e,scope.row.event_loing_recom_slot)">{{$t('tableText.추가')}}</el-button>
                 <el-tooltip class="item" effect="dark" content="요율없음 하부생성불가" placement="top"> 
                <el-button type="info" v-if="scope.row.is_add==0" icon="el-icon-circle-plus" size="mini" >{{$t('tableText.추가')}}</el-button> 
              </el-tooltip>
        
      </template>
        </el-table-column>
    
      
     
    </el-table>
        </el-tab-pane>
         <el-tab-pane  name="tab3">
           <span slot="label"><i class="el-icon-user-solid"></i>{{$t('nav.부본사관리')}}</span>
          <div class="d-flex align-items-center">
    
    <div class="">
      <el-form inline ref="form" :model="searchform">

      

          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value" :placeholder="$t('status.선택')" size="mini" style="width:120px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
            <template>
              <el-autocomplete v-model="searchform.keyword" :placeholder="$t('searchText.키워드')" :fetch-suggestions="querySearchAsync" :trigger-on-focus="false" @select="handleSelect"  style="width:150px"  size="mini" ></el-autocomplete>
              
            </template>
            <!--<template v-if="this.searchform.value == 'mem_id'">
               <el-autocomplete :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:150px"  :fetch-suggestions="querySearchAsync" @select="handleSelect"></el-autocomplete>
            </template>-->
            
          </el-form-item>
         
          <el-form-item  class="mb-0 mr-0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                  :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini"  value-format="yyyy-MM-dd" style="width:200px" >
                </el-date-picker>
          </el-form-item>
          
          
            <el-form-item  class="mb-0">
            <span class="text-muted mr-2" style="margin-top: -6px;">{{$t('msg.오늘접속')}}</span><el-checkbox true-label="1" false-label="0" v-model="searchform.online" style="vertical-align: middle;"></el-checkbox>
             <span class="text-muted mr-2" style="margin-top: -6px;">{{$t('msg.하부포함')}}</span><el-checkbox true-label="1" false-label="0" v-model="habu" style="vertical-align: middle;"></el-checkbox>
          </el-form-item>
          
          <el-form-item class="mb-0">
            <el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button> 
          <!--  <el-button type="success" size="mini" icon="el-icon-document-delete" @click="exportExcel" :disabled = "disabled">{{$t('searchText.엑셀다운')}}</el-button> -->
          </el-form-item>
           <el-form-item class="mb-0 mr-0">
           <el-button type="primary" size="mini" @click="openUserModel(false)" class="mb-2">{{$t('searchText.회원생성')}}</el-button>
          <!--<el-button type="primary"  size="mini"  @click="bonOpen(1,'','1')">{{$t('searchText.머니충환전')}}</el-button> --> 
          </el-form-item>
      </el-form>
       
    
    </div>
  
  </div>
  

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
     :span-method="objectSpanMethod"
      :cell-class-name="addClass"

      :header-cell-style="headerStyleEvent"
      :row-class-name="tableRowClassName"
       border
        class="mt-2 memlistTable memH"
        :empty-text="$t('tableText.데이타가없습니다')" @sort-change='tableSortChange'  @row-click="rowClick"  >
    
     <el-table-column width="50" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{(total*2-(currentPage-1)*size*2-scope.$index)/2}}</template>
        </el-table-column>
<el-table-column width="100" align="center"  :label="$t('newAdd.상부')" prop="dire">
 <template slot-scope="scope">
   <span @click="haha(scope.row.dire,scope.row.level)" style="color:#337ab7">{{scope.row.dire}}</span>
          </template>
        </el-table-column>
          <el-table-column label=""   align="center" width="45">

            <template slot-scope="scope">

              <span @click="haha(scope.row.mem_id,'m_code')" v-if="scope.row.mem_id==scope.row.m_code" class="bg-success text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px;background:#3e3e3e !important">MST</span>
              <span @click="haha(scope.row.mem_id,'s_code')" v-if="scope.row.mem_id==scope.row.s_code" class="bg-success text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px;background:#e54747 !important">{{$t('msg.본사')}}</span>
           <span @click="haha(scope.row.mem_id,'b_code')"  v-if="scope.row.mem_id==scope.row.b_code" class="bg-success text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px">{{$t('msg.부본')}}</span>
            <span @click="haha(scope.row.mem_id,'a_code')"  v-if="scope.row.mem_id==scope.row.a_code" class="bg-primary text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px">{{$t('msg.총판')}}</span>
            <span @click="haha(scope.row.mem_id,'c_code')"  v-if="scope.row.mem_id==scope.row.c_code " class="bg-warning text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px">{{$t('msg.매장')}}</span>
             <span  @click="haha(scope.row.mem_id,'m_cp')" v-if="scope.row.mem_id!=scope.row.a_code && scope.row.mem_id!=scope.row.b_code && scope.row.mem_id!=scope.row.c_code && scope.row.mem_id!=scope.row.s_code && scope.row.mem_id!=scope.row.m_code" class="bg-info text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px">{{$t('msg.유저')}}</span>
           </template>
        </el-table-column>

        <el-table-column v-if="this.sitetype=='4'" :label="$t('nav.아이디')"  prop="mem_id" align="center" width="170">
          <template slot-scope="scope">
            <div :style="{ backgroundColor :scope.row.RaceYN}">
            <span :class="scope.row.mem_status === '0' || scope.row.memState === '-2' ?'text-danger':''" @click="openModel(scope.row.mem_id,'tab1')" style="cursor:pointer">{{ scope.row.mem_id}}</span><span v-if="scope.row.mem_status === '0'" class="text-danger">(탈퇴)</span><br>(<span @click="openModel(scope.row.mem_id,'tab1')"  style="cursor:pointer">{{ scope.row.mem_name}}</span>) <el-tag type="success">V{{scope.row.memState}}</el-tag><span class="bg-danger ml-1 text-white px-1 py-1" style="border-radius:5px;" v-if="scope.row.add_time && scope.row.add_time>= logintime" @click="onTips">on</span>
          </div></template>
        </el-table-column>

     
        

   

        


    

        

        <template v-if="this.aid=='soft10' && this.sim!='1' " >

            <el-table-column :label="$t('msg.알잔액')"  prop="mem_cash" sortable="custom" align="center">
          <template slot-scope="scope"><span class="text-primary" @click="bonOpen(1,scope.row.mem_id,'1')"  style="cursor:pointer">{{ formatMoney(scope.row.mem_cash)}}</span></template>
        </el-table-column>

          <el-table-column :label="$t('msg.카슬머니')" prop="api_money" sortable="custom" align="center">
          <template slot-scope="scope"><span class="text-primary" @click="bonOpen(6,scope.row.mem_id,'1')"  style="cursor:pointer">{{ formatMoney(scope.row.api_money)}}</span></template>
        </el-table-column>

        <el-table-column :label="$t('msg.카슬롤링')" prop="mem_eventmoney" sortable="custom" align="center">
          <template slot-scope="scope"><span class="text-primary" @click="bonOpen(2,scope.row.mem_id,'1')"  style="cursor:pointer">{{ formatMoney(scope.row.mem_eventmoney)}}</span></template>
        </el-table-column>
         
   

        </template>

      

        <el-table-column  :label="$t('tableText.타입')"  prop="ca_title" align="center">
        
        </el-table-column>
        <el-table-column  :label="$t('msg.베팅')"  prop="ca_bet" align="center" sortable="custom">
         <template slot-scope="scope">
          <span :class="func(scope.row.ca_bet) " style="font-weight:bold"> {{ formatMoney(scope.row.ca_bet)}}</span>
         </template>
        </el-table-column>
       
        <el-table-column  :label="$t('msg.당첨')"  prop="ca_win" align="center" sortable="custom">
         <template slot-scope="scope">
           <span :class="func(scope.row.ca_win)"  style="font-weight:bold"> {{ formatMoney(scope.row.ca_win)}}</span>
         </template>
        </el-table-column>
          <el-table-column  :label="$t('newAdd.수수료')"  prop="ca_rog" align="center" sortable="custom">
         <template slot-scope="scope">
           <span :class="func(scope.row.ca_rog)" style="font-weight:bold"> {{ formatMoney(scope.row.ca_rog)}}</span>
         </template>
        </el-table-column>

        <el-table-column  :label="$t('newAdd.손익')"  prop="ca_tt" align="center" sortable="custom">
         <template slot-scope="scope">
           <span :class="func(scope.row.ca_tt)"  style="font-weight:bold"> {{ formatMoney(scope.row.ca_tt)}}</span>
         </template>
        </el-table-column>
      
        <el-table-column  :label="$t('newAdd.최종손익')"  prop="ca_total" align="center" sortable="custom">
         <template slot-scope="scope">
            <span :class="func(scope.row.ca_total)" style="font-weight:bold">{{ formatMoney(scope.row.ca_total)}}</span>
         </template>
        </el-table-column>


      

       

        <el-table-column v-if="this.sitetype==='2'"  :label="$t('msg.마지막입금')" width="115" sortable="custom" prop="last_money_date" align="center">
          <template slot-scope="scope">{{ scope.row.last_money_date ? scope.row.last_money_date.substring(0,10):""}}</template>
        </el-table-column>
         

     <!--    <el-table-column
           align="center"
          prop="memState"
          :label="$t('msg.등급')"
          >
          <template slot-scope="scope">
          <el-select :placeholder="$t('status.선택')" v-model="scope.row.memState" size="mini" style="width:80px" @change="changeOptions(scope)">
              <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
            </el-select>
      </template>
          </el-table-column>
         <el-table-column :label="$t('status.편집')" prop="mem_regdate" align="center">
         <template slot-scope="scope">
        
           <el-button-group>
                <el-button type="primary" icon="el-icon-edit" size="mini" @click="openModel(scope.row.mem_id)"></el-button>
                <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteAll(scope)"></el-button>
           </el-button-group>
        
      </template>
        </el-table-column> -->
         <el-table-column :label="$t('newAdd.설정')" width="260" align="center" class="mybuttonmini">
         <template slot-scope="scope">
        
           
                <el-button type="success" icon="el-icon-error" size="mini"  @click="openModel(scope.row.mem_id,'tab4')">{{$t('tableText.내손익')}}</el-button>
               <el-button type="success" icon="el-icon-error" size="mini"  @click="openModel(scope.row.mem_id,'tab48')">{{$t('newAdd.월정산')}}</el-button>
               <el-button type="warning" icon="el-icon-edit" size="mini"  @click="openModel(scope.row.mem_id,'tab3')">{{$t('searchText.요율')}}</el-button>
                <el-button type="danger" v-if="scope.row.is_add" icon="el-icon-circle-plus" size="mini" @click="userAdd(scope.row.mem_id,scope.row.gubun,scope.row.event_loing_e,scope.row.event_loing_slot,scope.row.event_loing_recom_e,scope.row.event_loing_recom_slot)">{{$t('tableText.추가')}}</el-button>
                 <el-tooltip class="item" effect="dark" content="요율없음 하부생성불가" placement="top"> 
                <el-button type="info" v-if="scope.row.is_add==0" icon="el-icon-circle-plus" size="mini" >{{$t('tableText.추가')}}</el-button> 
              </el-tooltip>
        
      </template>
        </el-table-column>
    
     
     
    </el-table>
        </el-tab-pane> <el-tab-pane  name="tab4">
           <span slot="label"><i class="el-icon-user-solid"></i>{{$t('nav.총판관리')}}</span>
          <div class="d-flex align-items-center">
    
    <div class="">
      <el-form inline ref="form" :model="searchform">

      

          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value" :placeholder="$t('status.선택')" size="mini" style="width:120px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
            <template>
              <el-autocomplete v-model="searchform.keyword" :placeholder="$t('searchText.키워드')" :fetch-suggestions="querySearchAsync" :trigger-on-focus="false" @select="handleSelect"  style="width:150px"  size="mini" ></el-autocomplete>
              
            </template>
            <!--<template v-if="this.searchform.value == 'mem_id'">
               <el-autocomplete :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:150px"  :fetch-suggestions="querySearchAsync" @select="handleSelect"></el-autocomplete>
            </template>-->
            
          </el-form-item>
         
          <el-form-item  class="mb-0 mr-0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                  :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini"  value-format="yyyy-MM-dd" style="width:200px" >
                </el-date-picker>
          </el-form-item>
          
          
            <el-form-item  class="mb-0">
            <span class="text-muted mr-2" style="margin-top: -6px;">{{$t('msg.오늘접속')}}</span><el-checkbox true-label="1" false-label="0" v-model="searchform.online" style="vertical-align: middle;"></el-checkbox>
             <span class="text-muted mr-2" style="margin-top: -6px;">{{$t('msg.하부포함')}}</span><el-checkbox true-label="1" false-label="0" v-model="habu" style="vertical-align: middle;"></el-checkbox>
          </el-form-item>
          
          <el-form-item class="mb-0">
            <el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button> 
          <!--  <el-button type="success" size="mini" icon="el-icon-document-delete" @click="exportExcel" :disabled = "disabled">{{$t('searchText.엑셀다운')}}</el-button> -->
          </el-form-item>
           <el-form-item class="mb-0 mr-0">
           <el-button type="primary" size="mini" @click="openUserModel(false)" class="mb-2">{{$t('searchText.회원생성')}}</el-button>
          <!--<el-button type="primary"  size="mini"  @click="bonOpen(1,'','1')">{{$t('searchText.머니충환전')}}</el-button> --> 
          </el-form-item>
      </el-form>
       
    
    </div>
  
  </div>
  

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
     :span-method="objectSpanMethod"
      :cell-class-name="addClass"

      :header-cell-style="headerStyleEvent"
      :row-class-name="tableRowClassName"
       border
        class="mt-2 memlistTable memH"
        :empty-text="$t('tableText.데이타가없습니다')" @sort-change='tableSortChange'  @row-click="rowClick"  >
    
     <el-table-column width="50" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{(total*2-(currentPage-1)*size*2-scope.$index)/2}}</template>
        </el-table-column>
<el-table-column width="100" align="center"  :label="$t('newAdd.상부')" prop="dire">
 <template slot-scope="scope">
   <span @click="haha(scope.row.dire,scope.row.level)" style="color:#337ab7">{{scope.row.dire}}</span>
          </template>
        </el-table-column>
          <el-table-column label=""   align="center" width="45">

            <template slot-scope="scope">

              <span @click="haha(scope.row.mem_id,'m_code')" v-if="scope.row.mem_id==scope.row.m_code" class="bg-success text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px;background:#3e3e3e !important">MST</span>
              <span @click="haha(scope.row.mem_id,'s_code')" v-if="scope.row.mem_id==scope.row.s_code" class="bg-success text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px;background:#e54747 !important">{{$t('msg.본사')}}</span>
           <span @click="haha(scope.row.mem_id,'b_code')"  v-if="scope.row.mem_id==scope.row.b_code" class="bg-success text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px">{{$t('msg.부본')}}</span>
            <span @click="haha(scope.row.mem_id,'a_code')"  v-if="scope.row.mem_id==scope.row.a_code" class="bg-primary text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px">{{$t('msg.총판')}}</span>
            <span @click="haha(scope.row.mem_id,'c_code')"  v-if="scope.row.mem_id==scope.row.c_code " class="bg-warning text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px">{{$t('msg.매장')}}</span>
             <span  @click="haha(scope.row.mem_id,'m_cp')" v-if="scope.row.mem_id!=scope.row.a_code && scope.row.mem_id!=scope.row.b_code && scope.row.mem_id!=scope.row.c_code && scope.row.mem_id!=scope.row.s_code && scope.row.mem_id!=scope.row.m_code" class="bg-info text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px">{{$t('msg.유저')}}</span>
           </template>
        </el-table-column>

        <el-table-column v-if="this.sitetype=='4'" :label="$t('nav.아이디')"  prop="mem_id" align="center" width="170">
          <template slot-scope="scope">
            <div :style="{ backgroundColor :scope.row.RaceYN}">
            <span :class="scope.row.mem_status === '0' || scope.row.memState === '-2' ?'text-danger':''" @click="openModel(scope.row.mem_id,'tab1')" style="cursor:pointer">{{ scope.row.mem_id}}</span><span v-if="scope.row.mem_status === '0'" class="text-danger">(탈퇴)</span><br>(<span @click="openModel(scope.row.mem_id,'tab1')"  style="cursor:pointer">{{ scope.row.mem_name}}</span>) <el-tag type="success">V{{scope.row.memState}}</el-tag><span class="bg-danger ml-1 text-white px-1 py-1" style="border-radius:5px;" v-if="scope.row.add_time && scope.row.add_time>= logintime" @click="onTips">on</span>
          </div></template>
        </el-table-column>

     
        

   

        


    

        

        <template v-if="this.aid=='soft10' && this.sim!='1' " >

            <el-table-column :label="$t('msg.알잔액')"  prop="mem_cash" sortable="custom" align="center">
          <template slot-scope="scope"><span class="text-primary" @click="bonOpen(1,scope.row.mem_id,'1')"  style="cursor:pointer">{{ formatMoney(scope.row.mem_cash)}}</span></template>
        </el-table-column>

          <el-table-column :label="$t('msg.카슬머니')" prop="api_money" sortable="custom" align="center">
          <template slot-scope="scope"><span class="text-primary" @click="bonOpen(6,scope.row.mem_id,'1')"  style="cursor:pointer">{{ formatMoney(scope.row.api_money)}}</span></template>
        </el-table-column>

        <el-table-column :label="$t('msg.카슬롤링')" prop="mem_eventmoney" sortable="custom" align="center">
          <template slot-scope="scope"><span class="text-primary" @click="bonOpen(2,scope.row.mem_id,'1')"  style="cursor:pointer">{{ formatMoney(scope.row.mem_eventmoney)}}</span></template>
        </el-table-column>
         
   

        </template>

      

        <el-table-column  :label="$t('tableText.타입')"  prop="ca_title" align="center">
        
        </el-table-column>
        <el-table-column  :label="$t('msg.베팅')"  prop="ca_bet" align="center" sortable="custom">
         <template slot-scope="scope">
          <span :class="func(scope.row.ca_bet) " style="font-weight:bold"> {{ formatMoney(scope.row.ca_bet)}}</span>
         </template>
        </el-table-column>
       
        <el-table-column  :label="$t('msg.당첨')"  prop="ca_win" align="center" sortable="custom">
         <template slot-scope="scope">
           <span :class="func(scope.row.ca_win)"  style="font-weight:bold"> {{ formatMoney(scope.row.ca_win)}}</span>
         </template>
        </el-table-column>
          <el-table-column  :label="$t('newAdd.수수료')"  prop="ca_rog" align="center" sortable="custom">
         <template slot-scope="scope">
           <span :class="func(scope.row.ca_rog)" style="font-weight:bold"> {{ formatMoney(scope.row.ca_rog)}}</span>
         </template>
        </el-table-column>

        <el-table-column  :label="$t('newAdd.손익')"  prop="ca_tt" align="center" sortable="custom">
         <template slot-scope="scope">
           <span :class="func(scope.row.ca_tt)"  style="font-weight:bold"> {{ formatMoney(scope.row.ca_tt)}}</span>
         </template>
        </el-table-column>
      
        <el-table-column  :label="$t('newAdd.최종손익')"  prop="ca_total" align="center" sortable="custom">
         <template slot-scope="scope">
            <span :class="func(scope.row.ca_total)" style="font-weight:bold">{{ formatMoney(scope.row.ca_total)}}</span>
         </template>
        </el-table-column>


      

       

        <el-table-column v-if="this.sitetype==='2'"  :label="$t('msg.마지막입금')" width="115" sortable="custom" prop="last_money_date" align="center">
          <template slot-scope="scope">{{ scope.row.last_money_date ? scope.row.last_money_date.substring(0,10):""}}</template>
        </el-table-column>
         

     <!--    <el-table-column
           align="center"
          prop="memState"
          :label="$t('msg.등급')"
          >
          <template slot-scope="scope">
          <el-select :placeholder="$t('status.선택')" v-model="scope.row.memState" size="mini" style="width:80px" @change="changeOptions(scope)">
              <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
            </el-select>
      </template>
          </el-table-column>
         <el-table-column :label="$t('status.편집')" prop="mem_regdate" align="center">
         <template slot-scope="scope">
        
           <el-button-group>
                <el-button type="primary" icon="el-icon-edit" size="mini" @click="openModel(scope.row.mem_id)"></el-button>
                <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteAll(scope)"></el-button>
           </el-button-group>
        
      </template>
        </el-table-column> -->
         <el-table-column :label="$t('newAdd.설정')" width="260" align="center" class="mybuttonmini">
         <template slot-scope="scope">
        
           
                <el-button type="success" icon="el-icon-error" size="mini"  @click="openModel(scope.row.mem_id,'tab4')">{{$t('tableText.내손익')}}</el-button>
               <el-button type="success" icon="el-icon-error" size="mini"  @click="openModel(scope.row.mem_id,'tab48')">{{$t('newAdd.월정산')}}</el-button>
               <el-button type="warning" icon="el-icon-edit" size="mini"  @click="openModel(scope.row.mem_id,'tab3')">{{$t('searchText.요율')}}</el-button>
                <el-button type="danger" v-if="scope.row.is_add" icon="el-icon-circle-plus" size="mini" @click="userAdd(scope.row.mem_id,scope.row.gubun,scope.row.event_loing_e,scope.row.event_loing_slot,scope.row.event_loing_recom_e,scope.row.event_loing_recom_slot)">{{$t('tableText.추가')}}</el-button>
                 <el-tooltip class="item" effect="dark" content="요율없음 하부생성불가" placement="top"> 
                <el-button type="info" v-if="scope.row.is_add==0" icon="el-icon-circle-plus" size="mini" >{{$t('tableText.추가')}}</el-button> 
              </el-tooltip>
        
      </template>
        </el-table-column>
    
    
  
     
    </el-table>
        </el-tab-pane> <el-tab-pane  name="tab5">
           <span slot="label"><i class="el-icon-user-solid"></i>{{$t('nav.매장관리')}}</span>
          <div class="d-flex align-items-center">
    
    <div class="">
      <el-form inline ref="form" :model="searchform">

      

          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value" :placeholder="$t('status.선택')" size="mini" style="width:120px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
            <template>
              <el-autocomplete v-model="searchform.keyword" :placeholder="$t('searchText.키워드')" :fetch-suggestions="querySearchAsync" :trigger-on-focus="false" @select="handleSelect"  style="width:150px"  size="mini" ></el-autocomplete>
              
            </template>
            <!--<template v-if="this.searchform.value == 'mem_id'">
               <el-autocomplete :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:150px"  :fetch-suggestions="querySearchAsync" @select="handleSelect"></el-autocomplete>
            </template>-->
            
          </el-form-item>
         
          <el-form-item  class="mb-0 mr-0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                  :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini"  value-format="yyyy-MM-dd" style="width:200px" >
                </el-date-picker>
          </el-form-item>
          
          
            <el-form-item  class="mb-0">
            <span class="text-muted mr-2" style="margin-top: -6px;">{{$t('msg.오늘접속')}}</span><el-checkbox true-label="1" false-label="0" v-model="searchform.online" style="vertical-align: middle;"></el-checkbox>
             <span class="text-muted mr-2" style="margin-top: -6px;">{{$t('msg.하부포함')}}</span><el-checkbox true-label="1" false-label="0" v-model="habu" style="vertical-align: middle;"></el-checkbox>
          </el-form-item>
          
          <el-form-item class="mb-0">
            <el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button> 
          <!--  <el-button type="success" size="mini" icon="el-icon-document-delete" @click="exportExcel" :disabled = "disabled">{{$t('searchText.엑셀다운')}}</el-button> -->
          </el-form-item>
           <el-form-item class="mb-0 mr-0">
           <el-button type="primary" size="mini" @click="openUserModel(false)" class="mb-2">{{$t('searchText.회원생성')}}</el-button>
          <!--<el-button type="primary"  size="mini"  @click="bonOpen(1,'','1')">{{$t('searchText.머니충환전')}}</el-button> --> 
          </el-form-item>
      </el-form>
       
    
    </div>
  
  </div>
  

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
     :span-method="objectSpanMethod"
      :cell-class-name="addClass"

      :header-cell-style="headerStyleEvent"
      :row-class-name="tableRowClassName"
       border
        class="mt-2 memlistTable memH"
        :empty-text="$t('tableText.데이타가없습니다')" @sort-change='tableSortChange'  @row-click="rowClick"  >
    
     <el-table-column width="50" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{(total*2-(currentPage-1)*size*2-scope.$index)/2}}</template>
        </el-table-column>
<el-table-column width="100" align="center"  :label="$t('newAdd.상부')" prop="dire">
 <template slot-scope="scope">
   <span @click="haha(scope.row.dire,scope.row.level)" style="color:#337ab7">{{scope.row.dire}}</span>
          </template>
        </el-table-column>
          <el-table-column label=""   align="center" width="45">

            <template slot-scope="scope">

              <span @click="haha(scope.row.mem_id,'m_code')" v-if="scope.row.mem_id==scope.row.m_code" class="bg-success text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px;background:#3e3e3e !important">MST</span>
              <span @click="haha(scope.row.mem_id,'s_code')" v-if="scope.row.mem_id==scope.row.s_code" class="bg-success text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px;background:#e54747 !important">{{$t('msg.본사')}}</span>
           <span @click="haha(scope.row.mem_id,'b_code')"  v-if="scope.row.mem_id==scope.row.b_code" class="bg-success text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px">{{$t('msg.부본')}}</span>
            <span @click="haha(scope.row.mem_id,'a_code')"  v-if="scope.row.mem_id==scope.row.a_code" class="bg-primary text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px">{{$t('msg.총판')}}</span>
            <span @click="haha(scope.row.mem_id,'c_code')"  v-if="scope.row.mem_id==scope.row.c_code " class="bg-warning text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px">{{$t('msg.매장')}}</span>
             <span  @click="haha(scope.row.mem_id,'m_cp')" v-if="scope.row.mem_id!=scope.row.a_code && scope.row.mem_id!=scope.row.b_code && scope.row.mem_id!=scope.row.c_code && scope.row.mem_id!=scope.row.s_code && scope.row.mem_id!=scope.row.m_code" class="bg-info text-white" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;font-size:11px">{{$t('msg.유저')}}</span>
           </template>
        </el-table-column>

        <el-table-column v-if="this.sitetype=='4'" :label="$t('nav.아이디')"  prop="mem_id" align="center" width="170">
          <template slot-scope="scope">
            <div :style="{ backgroundColor :scope.row.RaceYN}">
            <span :class="scope.row.mem_status === '0' || scope.row.memState === '-2' ?'text-danger':''" @click="openModel(scope.row.mem_id,'tab1')" style="cursor:pointer">{{ scope.row.mem_id}}</span><span v-if="scope.row.mem_status === '0'" class="text-danger">(탈퇴)</span><br>(<span @click="openModel(scope.row.mem_id,'tab1')"  style="cursor:pointer">{{ scope.row.mem_name}}</span>) <el-tag type="success">V{{scope.row.memState}}</el-tag><span class="bg-danger ml-1 text-white px-1 py-1" style="border-radius:5px;" v-if="scope.row.add_time && scope.row.add_time>= logintime" @click="onTips">on</span>
          </div></template>
        </el-table-column>

     
        

   

        


    

        

        <template v-if="this.aid=='soft10' && this.sim!='1' " >

            <el-table-column :label="$t('msg.알잔액')"  prop="mem_cash" sortable="custom" align="center">
          <template slot-scope="scope"><span class="text-primary" @click="bonOpen(1,scope.row.mem_id,'1')"  style="cursor:pointer">{{ formatMoney(scope.row.mem_cash)}}</span></template>
        </el-table-column>

          <el-table-column :label="$t('msg.카슬머니')" prop="api_money" sortable="custom" align="center">
          <template slot-scope="scope"><span class="text-primary" @click="bonOpen(6,scope.row.mem_id,'1')"  style="cursor:pointer">{{ formatMoney(scope.row.api_money)}}</span></template>
        </el-table-column>

        <el-table-column :label="$t('msg.카슬롤링')" prop="mem_eventmoney" sortable="custom" align="center">
          <template slot-scope="scope"><span class="text-primary" @click="bonOpen(2,scope.row.mem_id,'1')"  style="cursor:pointer">{{ formatMoney(scope.row.mem_eventmoney)}}</span></template>
        </el-table-column>
         
   

        </template>

      

        <el-table-column  :label="$t('tableText.타입')"  prop="ca_title" align="center">
        
        </el-table-column>
        <el-table-column  :label="$t('msg.베팅')"  prop="ca_bet" align="center" sortable="custom">
         <template slot-scope="scope">
          <span :class="func(scope.row.ca_bet) " style="font-weight:bold"> {{ formatMoney(scope.row.ca_bet)}}</span>
         </template>
        </el-table-column>
       
        <el-table-column  :label="$t('msg.당첨')"  prop="ca_win" align="center" sortable="custom">
         <template slot-scope="scope">
           <span :class="func(scope.row.ca_win)"  style="font-weight:bold"> {{ formatMoney(scope.row.ca_win)}}</span>
         </template>
        </el-table-column>
          <el-table-column  :label="$t('newAdd.수수료')"  prop="ca_rog" align="center" sortable="custom">
         <template slot-scope="scope">
           <span :class="func(scope.row.ca_rog)" style="font-weight:bold"> {{ formatMoney(scope.row.ca_rog)}}</span>
         </template>
        </el-table-column>

        <el-table-column  :label="$t('newAdd.손익')"  prop="ca_tt" align="center" sortable="custom">
         <template slot-scope="scope">
           <span :class="func(scope.row.ca_tt)"  style="font-weight:bold"> {{ formatMoney(scope.row.ca_tt)}}</span>
         </template>
        </el-table-column>
      
        <el-table-column  :label="$t('newAdd.최종손익')"  prop="ca_total" align="center" sortable="custom">
         <template slot-scope="scope">
            <span :class="func(scope.row.ca_total)" style="font-weight:bold">{{ formatMoney(scope.row.ca_total)}}</span>
         </template>
        </el-table-column>


      

       

        <el-table-column v-if="this.sitetype==='2'"  :label="$t('msg.마지막입금')" width="115" sortable="custom" prop="last_money_date" align="center">
          <template slot-scope="scope">{{ scope.row.last_money_date ? scope.row.last_money_date.substring(0,10):""}}</template>
        </el-table-column>
         

     <!--    <el-table-column
           align="center"
          prop="memState"
          :label="$t('msg.등급')"
          >
          <template slot-scope="scope">
          <el-select :placeholder="$t('status.선택')" v-model="scope.row.memState" size="mini" style="width:80px" @change="changeOptions(scope)">
              <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
            </el-select>
      </template>
          </el-table-column>
         <el-table-column :label="$t('status.편집')" prop="mem_regdate" align="center">
         <template slot-scope="scope">
        
           <el-button-group>
                <el-button type="primary" icon="el-icon-edit" size="mini" @click="openModel(scope.row.mem_id)"></el-button>
                <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteAll(scope)"></el-button>
           </el-button-group>
        
      </template>
        </el-table-column> -->
         <el-table-column :label="$t('newAdd.설정')" width="260" align="center" class="mybuttonmini">
         <template slot-scope="scope">
        
           
                <el-button type="success" icon="el-icon-error" size="mini"  @click="openModel(scope.row.mem_id,'tab4')">{{$t('tableText.내손익')}}</el-button>
               <el-button type="success" icon="el-icon-error" size="mini"  @click="openModel(scope.row.mem_id,'tab48')">{{$t('newAdd.월정산')}}</el-button>
               <el-button type="warning" icon="el-icon-edit" size="mini"  @click="openModel(scope.row.mem_id,'tab3')">{{$t('searchText.요율')}}</el-button>
                <el-button type="danger" v-if="scope.row.is_add" icon="el-icon-circle-plus" size="mini" @click="userAdd(scope.row.mem_id,scope.row.gubun,scope.row.event_loing_e,scope.row.event_loing_slot,scope.row.event_loing_recom_e,scope.row.event_loing_recom_slot)">{{$t('tableText.추가')}}</el-button>
                 <el-tooltip class="item" effect="dark" content="요율없음 하부생성불가" placement="top"> 
                <el-button type="info" v-if="scope.row.is_add==0" icon="el-icon-circle-plus" size="mini" >{{$t('tableText.추가')}}</el-button> 
              </el-tooltip>
        
      </template>
        </el-table-column>
    
     
  
     
    </el-table>
        </el-tab-pane>
      </el-tabs>
	
     <div style="height: 20px;"></div>

                      <el-footer class="border-top d-flex align-items-center px-0 bg-white" style="bottom: 20px;left: 200px;right: 0;z-index: 100;background:#fff!important">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[50,80,100]"
            hide-on-single-page

					  :page-size="this.size"
					  layout="sizes,prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
        
           
         <el-dialog
          :title="$t('tableText.추가')"
          :visible.sync="creatModel" :width="layoutWidth1" :close-on-click-modal ="false">

          <el-form ref="userform" :model="userform" label-width="100px" v-loading="loading" :rules="rules">
         <!--  <el-form-item :label="$t('newAdd.일괄생성')" class="mb-0 formItem2">
            <div class="d-flex">
             <el-checkbox true-label="1" false-label="0" v-model="pi" style="margin-left: -30px;"></el-checkbox>  
             <div v-if="this.pi==true">
               <el-input v-model="mins" class="mr-1 ml-1" type="number" maxlength="2" style="width: 70px;" placeholder="1"></el-input>  ~  <el-input v-model="maxs"  maxlength="2" class="ml-1  mr-1" type="number" style="width: 70px;" placeholder="30"></el-input> 
                <span class="ml-1 mr-1">번호앞에 0</span><el-select v-model="zerocc" :placeholder="$t('searchText.타이틀선택')" size="mini"  style="width: 120px;">
               <el-option
                      v-for="item in zerocclist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>   
              </div>  
              </div> 
          </el-form-item> -->
            <!--   <el-radio-group v-model="radio" @change="radioChange">
                 <div class="d-flex">
            <el-form-item :label="$t('tableText.총판선택')" prop="a_code" class="mb-0 formItem2 mr-2">
               <el-radio  class="mr-0 mb-0" label="1" style="margin-left: -30px;margin-top: 2px;">
                 <el-select v-model="userform.a_code" :placeholder="$t('searchText.타이틀선택')" size="mini" prop="boss"  :disabled="disabled1"  style="width: 150px;" filterable>
               <el-option
                      v-for="item in bubonlist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
               </el-radio>
              
            </el-form-item>
            <el-form-item :label="$t('searchText.매장선택')" prop="c_code" class="mb-0 w-50 formItem2">
               <el-radio class="mr-0 mb-0" label="2" style="margin-left: -30px;margin-top: 2px;">
                  <el-select v-model="userform.c_code" :placeholder="$t('searchText.타이틀선택')" size="mini" prop="boss"  :disabled="disabled2"   style="width: 150px;" filterable>
               <el-option
                      v-for="item in splist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
               </el-radio>
             
            </el-form-item>
              </div>
          </el-radio-group> -->
            <table class="table table-bordered myTable">
                <tr>
                  <td colspan="2">
                     <el-form-item :label="$t('nav.상위아이디')" class="mb-0 formItem">
                        <el-input v-model="userform.boss" class="w-25"></el-input>
                        <span class="ml-2 text-muted" style="font-size:13px !important">  *입력하지않으면 최상위아이디로 추가됩니다</span>
                    
                     </el-form-item>
                  </td>
              
                </tr>
                <tr>
                  <td width="50%">
                     <el-form-item :label="$t('nav.아이디')" prop="mem_id" class="mb-0 formItem">
                        <el-input v-model="userform.mem_id" class="w-75 mr-1"></el-input>
                        <el-button type="primary" size="mini" plain @click="reConfirm" :loading="reLoading">{{$t('msg.확인')}}</el-button>
                     </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('tableText.사용자암호')" prop="mem_pw" class="mb-0 formItem">
                    <el-input v-model="userform.mem_pw" class="w-75"></el-input>
                  </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                     <el-form-item  :label="$t('msg.닉네임')"  prop="mem_name" class="mb-0 formItem">
                        <el-input v-model="userform.mem_name" class="w-75"></el-input>
                      </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('msg.핸드폰')" class="mb-0 formItem" prop="mem_hp">
                            <el-input v-model="userform.mem_hp" class="w-75"></el-input>
                          </el-form-item>
                  </td>
                </tr>
                 <template v-if="(this.sitetype==='1' || this.sitetype==='3' || this.sitetype==='4') && this.power==='1'">
                <tr>
                  <td>
                     <el-form-item :label="$t('msg.파워볼일반')" class="mb-0 formItem" prop="event_loing">
                      <el-input v-model="userform.event_loing" class="w-75"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                     <el-form-item :label="$t('msg.파워볼조합')" class="mb-0 formItem" prop="event_loing_group">
                        <el-input v-model="userform.event_loing_group" class="w-75"></el-input>
                      </el-form-item>
                  </td>
                </tr>
             <!--   <tr>
                  <td>
                     <el-form-item label="사다리 일반" class="mb-0 formItem" prop="event_loing_s">
                        <el-input v-model="userform.event_loing_s" class="w-75"></el-input>
                      </el-form-item>
                  </td>
                  <td>
                      <el-form-item label="사다리 조합" class="mb-0 formItem" prop="event_loing_group_s">
                        <el-input v-model="userform.event_loing_group_s" class="w-75"></el-input>
                      </el-form-item>
                  </td>
                </tr>-->
                 </template>
                   <template v-if="this.bg==='1' ">
                    <tr>
                      <td>
                    <el-form-item :label="$t('msg.보글파일반')" class="mb-0 formItem" prop="event_loing1">
                      <el-input v-model="userform.event_loing1" class="w-75"></el-input>
                    </el-form-item>
                    </td>
                    <td>
                    <el-form-item :label="$t('msg.보글파조합')" class="mb-0 formItem" prop="event_loing_group1">
                      <el-input v-model="userform.event_loing_group1" class="w-75"></el-input>
                    </el-form-item>
                  </td>
                  </tr>
                   <tr>
                      <td>
                    <el-form-item :label="$t('msg.보글사일반')" class="mb-0 formItem" prop="event_loing_s1">
                      <el-input v-model="userform.event_loing_s1" class="w-75"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                    
                    <el-form-item :label="$t('msg.보글사조합')" class="mb-0 formItem" prop="event_loing_group_s1">
                      <el-input v-model="userform.event_loing_group_s1" class="w-75"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                    </template>
                     <template v-if="this.sitetype==='4'">
                      <tr>
                        <td>
                           <el-form-item label="카지노롤링"  class="mb-0 formItem" prop="event_loing_e">
                              <el-input v-model="userform.event_loing_e" class="w-75"></el-input>
                            </el-form-item>
                        </td>
                        <td>
                          <el-form-item :label="$t('msg.슬롯롤링')" class="mb-0 formItem" prop="event_loing_slot">
                              <el-input v-model="userform.event_loing_slot" class="w-75"></el-input>
                            </el-form-item>
                        </td>
                      </tr>
                     
                      
                     
                     </template>
                     <tr>
                       <td>
                           <el-form-item :label="$t('tableText.출금비번')" class="mb-0 formItem" prop="mem_jumin">
                          <el-input v-model="userform.mem_jumin" class="w-75"></el-input>
                        </el-form-item> 
                       </td>
                       <td>
                          <el-form-item :label="$t('tableText.은행명')" class="mb-0 formItem" prop="mem_bankcode">
                            <el-input v-model="userform.mem_bankcode" class="w-75"></el-input>
                          </el-form-item>
                       </td>
                     </tr>
                      <tr>
                       <td>
                         <el-form-item :label="$t('tableText.계좌번호')" class="mb-0 formItem" prop="mem_banknum">
                            <el-input v-model="userform.mem_banknum" class="w-75"></el-input>
                          </el-form-item>
                       </td>
                       <td>
                         <el-form-item :label="$t('msg.예금주')" class="mb-0 formItem" prop="mem_bankname">
                            <el-input v-model="userform.mem_bankname" class="w-75"></el-input>
                          </el-form-item>
                       </td>
                     </tr>
                     

            </table>
 
          </el-form>
          <span slot="footer" class="dialog-footer ">
          <!--   <div class="mr-auto">
               <el-button type="success" @click="shopAdd" size="medium">{{$t('msg.파트너생성')}}</el-button>
               
            </div> -->
             <el-button @click="creatModel = false" size="medium">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="submitForm" :disabled="disabled" size="medium">{{$t('msg.확인')}}</el-button>
          </span>
        
       
       
        </el-dialog>
        <!-- 遮罩层 -->
      <div class="dialogLayer" v-show="shareShow" @click="shareShow=!shareShow">
      </div>
				
</div>
 </template>

 <table id="my-table-id">
  <th><td>dddd</td></th>
   <tr><td>test</td></tr>
 </table>

 <script>

const windowHeight = parseInt(window.innerHeight)
  import * as XLSX from 'xlsx/xlsx.mjs';
 import shopDialog from '../../components/common/shop-dialog.vue';
 import layoutLayer from '../../components/common/layout-layer.vue';
  import editLayer from '../../components/common/edit-layer.vue';
 import layer from '../../components/common/layer.vue';
 import layerNew from '../../components/common/layer-new.vue';
 import EventBus from '../../assets/js/eventBus.js';
import bonAdd from '../../components/common/bon-add.vue';
import bubonAdd from '../../components/common/bubon-add.vue';
import shopAdd from '../../components/common/shop-add.vue';
import zpAdd from '../../components/common/zp-add.vue';
import userAdd from '../../components/common/user-add.vue';
    export default {
     components: {
      layer,layoutLayer,layerNew,editLayer,
         shopDialog,bonAdd,bubonAdd,shopAdd,zpAdd,userAdd
    },
    	data(){
    		return{
         screenWidth: window.innerWidth,
          mem_gubun:'',
          habu:'1',
          userData:[],
          reLoading:false,
           shareShow:false,
           join_dg_s:'0',
           gameusers_s:'0',
          userDatatree:[],
            adminlist:[{
                 label:this.$i18n.t("status.선택"),
                value:''
            },
            
            ],
             admin_id:'',
          activeName: 'tab1',
           tapidx:"0",
           tabname:'',
          zerocclist:[
            {
              label: this.$i18n.t("newAdd.없음"),
              value: '0',
            },
             {
              label: '하나',
              value: '1',
            }, {
              label: '두개',
              value: '2',
            }
            ],
          zerocc:'0',
          pi:false,
          mins:'1',
          maxs:'30',
          windowHeight: windowHeight,
          tableHeight:0,
          layoutWidth1:'600px',
          restaurants: [],
          state: '',
          timeout:  null,
          dWidth:'400px',

           logintime:null,

           io_type:'',
           ioType: [
               {
                label: this.$i18n.t("msg.충전"),
                 value: '1',
               
              }, {
                label: this.$i18n.t("msg.환전"),
                 value: '2',
               
              }],
          form:{
            mem_id:'',
            money:'',
            memo:'',
          },
           options1: [{
               
                label: this.$i18n.t("msg.게임머니"),
                 value: '1',
               
              }],
           gubun:'',
          dialogModel:false,
          disabled:false,
          total:0,
         userid:window.sessionStorage.getItem('userid'),
          aid:window.sessionStorage.getItem('admin_id'),
          domain:window.sessionStorage.getItem('domain'),
          sitetype:window.sessionStorage.getItem('sitetype'),
          bg:window.sessionStorage.getItem('bg'),
          power:window.sessionStorage.getItem('power'),
          rosing:window.sessionStorage.getItem('rosing'),
          sim:window.sessionStorage.getItem('sim'),
          formLoading:false,
          idDialogVisible: false,
          iconObj:{
              '1':'bg-primary',
              '2':'bg-danger',
              '3':'',
              '4':'bg-yellow',             
            },
          order:'descending',
          prop:'mem_regdate',
    		
				total_emoney: '',
				total_money: '',
        total_amoney: '',
        total_power: '',
        total_epower: '',
        options: [{
              label: this.$i18n.t("msg.블랙"),
              value: '-2',
             
            }, {
              label: this.$i18n.t("msg.대기"),
               value: '-1',
              
            }, {
              label: this.$i18n.t("msg.기본"),
               value: '0',
             
            }, {
              label: 'v1',
               value: '1',
             
            }, {
              label: 'v2',
               value: '2',
             
            }, {
              label: 'v3',
               value: '3',
             
            }, {
              label: 'v4',
               value: '4',
             
            }, {
              label: 'v5',
               value: '5',
             
            }, {
              label: 'v6',
               value: '6',
             
            }, {
              label: 'v7',
               value: '7',
             
            }, {
              label: 'co',
               value: '8',
             
            }],
          bubonlist:[{
                label:this.$i18n.t("status.선택"),
              value:''
            }
            
            ],
            splist:[{
                label:this.$i18n.t("status.선택"),
              value:''
            }
            
            ],
    		  userform:{
            agent_name:'',
            shop_name:'',
            boss:'',
             a_code:'',
             c_code:'',
            mem_pw:'',
            mem_name:'',
            mem_id:'',
             id:'',
            
            event_loing_recom:'0',
            event_loing_recom_s:'0',
            event_loing_group_recom:'0',
            event_loing_group_recom_s:'0',

            event_loing:'0',
            event_loing_group:'0',
            event_loing_s:'0',
            event_loing_group_s:'0',



            event_loing_recom1:'',
            event_loing_recom_s1:'',
            event_loing_group_recom1:'',
            event_loing_group_recom_s1:'',

            event_loing1:'',
            event_loing_group1:'',
            event_loing_s1:'',
            event_loing_group_s1:'',


            event_loing_e:'',
            event_loing_slot:'',
           


              mem_banknum:'',
            mem_bankcode:'',
            mem_bankname:'',
            mem_jumin:'',
            mem_hp:'',
           memlist_id:'',
            status:'',
           
          },
         radio:'2',
         disabled1:true,
         disabled2:false,
    			searchform:{
            live:false,
            online:false,
    				keyword:'',
    				time:[],
            user_searchOptions:[
                
            {
              label:this.$i18n.t("tableText.마스터선택"),
              value:'m_code'
            },{
              label:this.$i18n.t("tableText.본사선택"),
              value:'s_code'
            },

            ],
    				searchOptions:[
             
             {
              label:this.$i18n.t("nav.아이디"),
              value:'mem_id'
            },
               
           
    				  {
              label:this.$i18n.t("msg.닉네임"),
              value:'mem_name'
            },
              {
              label:this.$i18n.t("msg.예금주"),
              value:'mem_bankname'
            },
            
            {
              label:this.$i18n.t("msg.핸드폰"),
              value:'mem_hp'
            }
           
		        ],

            searchOptions_pt:[
             
            {
              label:this.$i18n.t("nav.아이디"),
              value:'mem_id'
            }
            ],
		       
		        value:'mem_id',
            user_value:'',
              searchOptions2:[
               
           {
              label:this.$i18n.t("msg.가입시"),
              value:'mem_regdate'
            }, 
            {
              label:this.$i18n.t("msg.입금시"),
              value:'last_money_date'
            },
           
            ],
           
            value2:'',
             searchOptions3:[
               
            {
               label:this.$i18n.t("msg.블랙"),
              value:'-2'
            }, 
            {
              label:this.$i18n.t("msg.대기"),
              value:'-1'
            },
            {
              label:this.$i18n.t("msg.기본"),
              value:'0'
            },
            {
              label:'V1',
              value:'1'
            },
            {
              label:'V2',
              value:'2'
            },
            {
              label:'V3',
              value:'3'
            },
            {
              label:'V4',
              value:'4'
            },
            {
              label:'V5',
              value:'5'
            },
            {
              label:'V6',
              value:'6'
            },
            {
              label:'V7',
              value:'7'
            },
            {
              label:'co',
              value:'8'
            }           
            ],
            value3:[],
		        


    			},

           rules: {
                  mem_jumin:[{ required: true, message: '', trigger: 'blur'}],
                  
                  event_loing_recom:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_recom_s:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_group_recom:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_group_recom_s:[{ required: true, message: '', trigger: 'blur'}],

                  event_loing:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_s:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_group:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_group_s:[{ required: true, message: '', trigger: 'blur'}],

                  event_loing_e:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_slot:[{ required: true, message: '', trigger: 'blur'}],

                  //agent_name:[{ required: true, message: '', trigger: 'blur'}],
                  mem_bankname:[{ required: true, message: '', trigger: 'blur'}],
                  mem_hp:[{ required: true, message: '', trigger: 'blur'}],
                  mem_bankcode:[{ required: true, message: '', trigger: 'blur'}],
                  mem_banknum:[{ required: true, message: '', trigger: 'blur'}],
                  mem_id:[{ required: true, message: '', trigger: 'blur'}],
                  mem_name:[{ required: true, message: '', trigger: 'blur'}],
                  mem_pw:[{ required: true, message: '', trigger: 'blur'}],

                  //a_code:[{ required: true, message: '', trigger: 'blur'}],
                },
    			 pickerOptions: {
    			},
          shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        
    
      
		    		 total:0,
		    		 size:50,
		    		 loading: false,
		    		 editIndex:-1,
		    		 creatModel:false,
		    		 tableData: [],
			       currentPage:1,
			       multipleSelection:[],
			       superSearch:false,  
             layLoading:false,
             currentRowId:'',
			 
    			}
    			
    			
    		},
       mounted() {
     
 
         

    },
    

    

    		created() {

       //   console.log('tab7==',this.$route.params.activeName)
           
            this.getHeight()
          let token=window.sessionStorage.getItem('user');
          

      
    	  if(this.sitetype=="3")
        {
                this.options1=[{
               
                label: this.$i18n.t("msg.게임머니"),
                 value: '1',
               
              }, {
                label: this.$i18n.t("msg.이벤트머니"),
                 value: '2',
               
              }, {
                label: this.$i18n.t("msg.롤링머니"),
                 value: '3',
               
              }];
        }
        else
        {
                this.options1=[{
               
                 label: this.$i18n.t("msg.게임머니"),
                 value: '1',
               
                }, {
                 label: this.$i18n.t("msg.이벤트머니"),
                 value: '2',
               
               }];
        }
    	
          this.tabsCode();

		//	console.log('screenWidth',this.screenWidth)
		},
    	
    	methods:{
        tabsCode() {
        // 比较结果activeName的值
        if (this.$route.query.activeName != null) {
          this.activeName = this.$route.query.activeName;
          
          let current7=this.activeName
          if(current7 == "tab7"){
              this.tabname = "tab7"
              this.tapidx="6"
            
            //  console.log('active',this.tabname)
          }
        
          
        else if(current7 == "tab5"){
            this.tabname = "tab5"
        //  console.log('active5',this.tabname)
        }
          
          }
        
        this.getList()
      },

        getHeight () {
            // 初始化的时候，设置高度
      this.setHeight()
      // 改变浏览器窗口大小的时候，设置高度
      window.addEventListener('resize', () => {
        this.setHeight()
      })

           },
           setHeight() {
              this.$nextTick(() => {
              this.tableHeight = windowHeight -200 
            //  console.log(this.tableHeight)
      })
    },
    func(state){
      if(state > 0){
        return "text-success"
      }else if(state <0){
         return "text-danger"
      }else if(state ===0){
         return ""
      }
    },
     objectSpanMethod({ row, column, rowIndex, columnIndex }) {
       let v=this.tapidx;

     //  console.log('');
      
     
    
          if (columnIndex === 0 ||columnIndex === 1||columnIndex === 2 ||columnIndex === 3||columnIndex === 4 ||columnIndex === 5 ||columnIndex === 6 ||columnIndex === 12||columnIndex === 13) {
          if (rowIndex % 2 === 0) {
            return {
              rowspan: 2,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
       

       
      },
      bonAdd(){
           
           this.$layer.iframe({
            type: 2,
            title: '추가',
            content: {
                content: bonAdd,
                parent: this,
                data:{
               
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['800px', '500px'],
           
        });
        
        },
       
         shopAdd(){
           
           this.$layer.iframe({
            type: 2,
            title: '파트너추가',
            content: {
                content: shopAdd,
                parent: this,
                data:{
               
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['800px', '480px'],
           
        });
        
        },
        zpAdd(){
           
           this.$layer.iframe({
            type: 2,
            title: '추가',
            content: {
                content: bonAdd,
                parent: this,
                data:{
               
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['800px', '500px'],
           
        });
        
        },
      querySearchAsync(queryString, cb) {
       let token=window.sessionStorage.getItem('user');

       if(this.searchform.value!="mem_id")
       {
          //return [];
       }
           
              this.$axios({
                    method:'put',
                    url:this.domain+'/user/id_like?'+this.searchform.value+'='+this.searchform.keyword,
                   
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 

               let item = response.data.data.data;

               this.restaurants = item;
                   // return this.restaurants;

                  var restaurants = this.restaurants;
                 //console.log('restaurants==',restaurants)
                          // 解决element建议搜索框无法显示内容 的数据处理
                          for (var i = 0; i < restaurants.length; i++) {
                            restaurants[i].value = restaurants[i].mem_id;
                          }
                          var results = queryString
                            ? restaurants.filter(this.createStateFilter(queryString))
                            : restaurants;
                          // 调用 callback 返回建议列表的数据
                          clearTimeout(this.timeout);
                          this.timeout = setTimeout(() => {
                            cb(results);
                          }, 50 * Math.random());
                                      
   
                 
              }).catch((error) =>{
                 this.$message({
                          message:'error',
                          type:'error'
                      })   

                   
              })
    },
     addClass({row,column,rowIndex,columnIndex}){
   //   console.log('row',row)

      let v=this.tapidx;
     
         if (columnIndex == 8 || columnIndex == 9||columnIndex == 10 || columnIndex == 11|| columnIndex == 7) {
        if(rowIndex%2===0){
           return 'bgx-p';
         }else{
           return 'bgx-b';
         }

        
      }
      
    
     
     
     },
     headerStyleEvent({ row, column, rowIndex, columnIndex }){
      let v=this.tapidx;
     
    
     
         if (columnIndex == 8 || columnIndex == 9||columnIndex == 10 || columnIndex == 11||columnIndex == 12 ||columnIndex == 7) {
        return 'background-color:#fff5f5!important;color:#333'
       }
       else{
        return 'color:#333;'
       }
      
      
     },
    tableRowClassName({row, rowIndex}) {
      if(this.currentRowId===row.mem_id){
        return 'bgx';
      }
       if (rowIndex%2 === 1) {
        return 'odd-row';
       }
       else{
         return 'edd-row';
       }
    },
     tableRowClassName1({row, rowIndex}) {
       if (rowIndex%2 === 1) {
        return 'odd-row-1';
       }
       else{
         return 'edd-row-1';
       }
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.mem_id.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },

      handleSelect(item) {
       // console.log('item',item.mem_id);
        this.searchform.keyword = item.mem_id;
      },

         bonOpen(e,id,type){
           this.$layer.iframe({
            type: 2,
            title: '머니충환전',
            content: {
                content: layoutLayer,
                parent: this,
                data:{
                einfo:{e:e},
                info:{id:id,type:type},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['580px', '480px'],
        });
        

        },
           editOpen(id,ut){
           this.$layer.iframe({
            type: 2,
            title: id+this.$i18n.t("newAdd.제한설정"),
            content: {
                content: editLayer,
                parent: this,
                data:{
               
                info:{id:id,user_type:ut},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['580px', '265px'],
        });
        
        },
        rowClick(row, column, event) {
          this.currentRowId=row.mem_id
       //    console.log('row',row)
           
           
          },

          userAdd(id,gubun,event_loing_e,event_loing_slot,event_loing_recom_e,event_loing_recom_slot){
           
           
           if(gubun=='m_cp')
           {
              this.$layer.iframe({
              type: 2,
              title: '회원추가',
              content: {
                  content:userAdd,
                  parent: this,
                  data:{
                  info:{
                    id:id,
                    event_loing_e:event_loing_e,
                    event_loing_slot:event_loing_slot
                  },
                  layerid:'id'
                  }
                
              },
              shadeClose: false,
               maxmin : true,

              shade: false,
              area: ['800px', '430px'],
             
             });
           }else if(gubun=='c_code')
           {
              this.$layer.iframe({
              type: 2,
              title: '회원추가',
              content: {
                  content:userAdd,
                  parent: this,
                  data:{
                  info:{
                    id:id,
                    event_loing_e:event_loing_recom_e,
                    event_loing_slot:event_loing_recom_slot
                  },
                  layerid:'id'
                  }
                
              },
              shadeClose: false,
               maxmin : true,

              shade: false,
              area: ['800px', '430px'],
             
             });
           }

           else
           {
              this.$layer.iframe({
              type: 2,
              title: '파트너추가',
              content: {
                  content:shopAdd,
                  parent: this,
                  data:{
                  info:{
                    id:id,
                    event_loing_recom_e:event_loing_recom_e,
                    event_loing_recom_slot:event_loing_recom_slot
                  },
                  layerid:'id'
                  }
                
              },
              shadeClose: false,
               maxmin : true,

              shade: false,
              area: ['800px', '470px'],
             
             });
           }
           
        
        },

         adminChange(v){
          //console.log(v)
          this.admin_id=v
          this.getList()
        },
        onTips(){
          this.$message({
            message:'...',
            type:'warning'
          })
        },

         haha(e,code){

          return;
          
          this.activeName = "tab2"
          this.tabname = "tab2"
          this.tapidx="1"
          this.mem_gubun=code
            
             
          

          this.searchform.value='mem_id';
          this.searchform.keyword=e
          this.currentPage=1;
          this.getList();
          
             
        },

         openAgentModel(id){


          //判断分辨率
          let pix=window.screen.width;
          let width=1100;
          if(pix<1100)
          {
            width=700;
          }
          this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: shopDialog,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: [width+'px', '350px'],
            success: function(layero){
            $(layero).addClass("scroll-wrapper");//苹果 iframe 滚动条失效解决方式
        }
           
        });
       
        },
         submitForm(){
              let token=window.sessionStorage.getItem('user');
              
              
              this.$refs.userform.validate((e)=>{
             if(!e) return;

                 this.disabled = true
                 this.loading =true
                 this.$axios({
                        method:'post',
                        url:this.domain+'/user/pt_insert',
                        data:{
                        
                         
                          mem_pw:this.userform.mem_pw,
                          mem_name:this.userform.mem_name,
                          id:this.userform.idx,
                          mem_id:this.userform.mem_id,
                          boss:this.userform.boss,
                          event_loing:this.userform.event_loing,
                          event_loing_s:this.userform.event_loing_s,
                          event_loing_group:this.userform.event_loing_group,
                          event_loing_group_s:this.userform.event_loing_group_s,

                          event_loing_e:this.userform.event_loing_e,
                          event_loing_slot:this.userform.event_loing_slot,
                       
                          mem_banknum:this.userform.mem_banknum,
                          mem_bankcode:this.userform.mem_bankcode,
                          mem_bankname:this.userform.mem_bankname,
                          mem_jumin:this.userform.mem_jumin,
                          mem_hp:this.userform.mem_hp,
                          pi:this.pi,
                          mins:this.mins,
                          maxs:this.maxs,
                          zerocc:this.zerocc
                          
                         
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                                  message:response.data.msg,
                                  type: 'warning'
                                });
                                
                            }else{
                               this.$message({
                                  message:response.data.msg,
                                  type: 'success'
                                });
                               //console.log(this.form);
                               //this.getList();
                         this.activeName = "tab5"
                         
                          this.creatModel = false
                          this.tabname = "tab5"
                          this.getList();

                            }
                           this.loading =false
                           this.disabled = false
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                       this.loading =false
                           this.disabled = false
                  })
              
            
            })
              
            
        },
       handleClick(tab, event) {
              this.currentPage=1
              this.tabname = tab.name
              this.searchform.keyword='';
              this.searchform.value='';
              this.mem_gubun='';
              this.prop='mem_regdate';
              this.order='descending';


              
              this.tapidx=tab.index
              this.getList()
      },
         radioChange(val){
          //console.log('val',val)
          this.disabled2 = (val==='1') ? true : false
          this.disabled1 = (val==='2') ? true : false
        },
         
         openUserModel(e = false){
          let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'get',
                  url:this.domain+'/user/zplist_select?shop=1',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
               //  console.log(response.data.data);

                 let newids=[];

                 let newids2=[];


           response.data.data.forEach(item=>{
            let obj={};
            obj.label=item.code+"("+item.agent_name+")"
            obj.value=item.code
            newids.push(obj);
           });


          this.bubonlist=newids

          response.data.data2.forEach(item=>{
            let obj={};
            obj.label=item.code+"("+item.shop_name+")"
            obj.value=item.code
            newids2.push(obj);
           });


          this.splist=newids2

                 
                  
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })

            //console.log('add');
            this.userform = {
                  agent_name:'',
                  shop_name:'',
                  a_code:'',
                  c_code:'',
                  mem_pw:'',
                  mem_name:'',
                  mem_id:'',
                  event_loing_group_recom:'0',
                  event_loing_group_recom_s:'0',
                  event_loing_recom:'0',
                  event_loing_recom_s:'0',


                    event_loing:0,
                          event_loing_s:0,
                          event_loing_group:0,
                          event_loing_group_s:0,

                    event_loing1:0,
                          event_loing_s1:0,
                          event_loing_group1:0,
                          event_loing_group_s1:0,

                  mem_banknum:'',
                  mem_bankcode:'',
                  mem_bankname:'',
                  mem_jumin:'',
                  mem_hp:'',
                  status:'1'
                  

                 }

          this.creatModel = true
        },
         // 关闭弹框（头部的X）
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
       exportExcel() {
       },

         openModel(id,e){
        //  console.log('e=',e)
           if(this.aid=='soft10')
           {
                this.shareShow = true
                let pix=window.screen.width;
           
                let width='1200px';
                if(pix<1200)
                {
                  width='95%';
                }

                this.$layer.iframe({
                type: 2,
                title: id,
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    activeTab:e,
                    model:this.shareShow,
                    layerid:'id'
                    }
                  
                },
              
                shadeClose: true,
                maxmin:true,
                shade: false,
                area: [width+'', '740px'],
                cancel:()=>{
                  this.shareShow = false
                  console.log(close)
                }
                
             
             });

              return;
           }
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['830px', '680px'],
         
        });

        },
        cancelEvent(){
          this.shareShow = false
        },
    			 // 搜索事件
			searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                	  this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                	 return;
                }

              
              this.currentPage=1;


    			this.getList();
    			
             

    		},
        tableSortChange(column) {
 
         this.prop= column.prop
         this.order= column.order
          this.currentPage=1;
         
        this.getList()
     },
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			     
    		getList(){

    		   

               let s_time="";
               let e_time="";
               let ttname=this.tabname;
               if(this.searchform.time && this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

            //   console.log(ttname)

            

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			
           let urls='';
             if(ttname=="tab1" || ttname=="")
             {
                urls=this.domain+'/user/memlist2?habu='+this.habu+'&timetype='+this.searchform.value2+'&limit='+this.size+'&online='+this.searchform.online+'&live='+this.searchform.live+'&level='+this.searchform.value3+'&fit='+this.prop+'&order='+this.order+'&io_type=1'+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage+'&level=m_code'
             }else if(ttname=="tab2"){
               //保留
               urls=this.domain+'/user/memlist2?habu='+this.habu+'&timetype='+this.searchform.value2+'&limit='+this.size+'&online='+this.searchform.online+'&live='+this.searchform.live+'&level='+this.searchform.value3+'&fit='+this.prop+'&order='+this.order+'&io_type=1'+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage+'&level=s_code'

             }else if(ttname=="tab3"){

                urls=this.domain+'/user/memlist2?habu='+this.habu+'&timetype='+this.searchform.value2+'&limit='+this.size+'&online='+this.searchform.online+'&live='+this.searchform.live+'&level='+this.searchform.value3+'&fit='+this.prop+'&order='+this.order+'&io_type=1'+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage+'&level=b_code'
             }
             else if(ttname=="tab4"){

               urls=this.domain+'/user/memlist2?habu='+this.habu+'&timetype='+this.searchform.value2+'&limit='+this.size+'&online='+this.searchform.online+'&live='+this.searchform.live+'&level='+this.searchform.value3+'&fit='+this.prop+'&order='+this.order+'&io_type=1'+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage+'&level=a_code'
             }
             else if(ttname=="tab5"){

               urls=this.domain+'/user/memlist2?habu='+this.habu+'&timetype='+this.searchform.value2+'&limit='+this.size+'&online='+this.searchform.online+'&live='+this.searchform.live+'&level='+this.searchform.value3+'&fit='+this.prop+'&order='+this.order+'&io_type=1'+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage+'&level=c_code'
             }
            
           
    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                   //  console.log('data=',response.data.data)
                     let data = response.data.data
                     

                  // this.join_dg_s=response.data.join_dg_s
                     this.tableData =data.data
                     this.userData =data

                     this.total = data.total
                     
                     this.total = data.total/2
                     

                     this.currentPage = data.current_page
                     this.size =data.per_page
                     

                   

                     this.logintime=response.data.logintime
                 


                     this.loading =false
               
            }).catch((error) =>{
            	
               this.$message.error(error);
              this.loading = false
               
            })
    		},
        // 删除
      deleteAll(e){
       this.$prompt(e.row.mem_id+' '+this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          inputPlaceholder:this.$i18n.t("newAdd.인증번호"),
          type: 'warning'
        }).then(({ value }) => {
          let token=window.sessionStorage.getItem('user');
   

          this.$axios({
                      method:'post',
                      url:this.domain+'/user/mem_del?opt='+value+'&mem_id='+e.row.mem_id,
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                     this.loading = false
                    
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
           message:this.$i18n.t("msg.취소됨")
          });          
        });

        
      },  
       memLevelUp(e){
       this.$confirm(e.mem_id+' '+this.$i18n.t("msg.탈퇴하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.탈퇴"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');

          this.$axios({
                      method:'post',
                      url:this.domain+'/user/mem_level_up',
                       data:{
                       mem_status:'0',
                       id:e.mem_id
                    },
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'

                    })

                       this.loading = false

                    }else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                    
                    
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
           message:this.$i18n.t("msg.취소됨")
          });          
        });

        
      },  
    		changeOptions(e){
               let token=window.sessionStorage.getItem('user');
               this.$axios({
                    method:'post',
                    url:this.domain+'/user/mem_level_up',
                    data:{
                       level:e.row.memState,
                       id:e.row.mem_id
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
                }).then((response) =>{ 
                   console.log()
                   if(response.data.code==200)
                      {
                      	 this.$message({
		                      message:this.$i18n.t("msg.완료"),
		                      type: 'success'
		                    });

                          this.getList();
                         
                          
                      }else{
                       this.$message.error(response.data.msg)

                      }

                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
            },
              changeLevel(id,type){
               let token=window.sessionStorage.getItem('user');
               this.$axios({
                    method:'post',
                    url:this.domain+'/user/mem_level_up',
                    data:{
                       level:type,
                       id:id
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
                }).then((response) =>{ 
                   console.log()
                   if(response.data.code==200)
                      {
                         this.$message({
                          message:this.$i18n.t("msg.완료"),
                          type: 'success'
                        });

                          this.getList();
                         
                          
                      }else{
                       this.$message.error(response.data.msg)

                      }

                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
            },
            blackRestore(e){
              this.$confirm(this.$i18n.t("msg.복구하시겠습니까"),this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.복구"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
           let token=window.sessionStorage.getItem('user');
               this.$axios({
                    method:'post',
                    url:this.domain+'/user/black_restore',
                    data:{
                      
                       mem_id:e.row.mem_id
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
                }).then((response) =>{ 
                   console.log()
                   if(response.data.code==200)
                      {
                         this.$message({
                          message:response.data.msg,
                          type: 'success'
                        });

                          this.getList();
                         
                          
                      }else{
                       this.$message.error(response.data.msg)

                      }

                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })

        })
              
            },
            reConfirm(){
               let token=window.sessionStorage.getItem('user');
              
               if(this.userform.mem_id=='')
               {
                    this.$message.error('id error')
                    return;
               }

                this.reLoading = true
               this.$axios({
                    method:'post',
                    url:this.domain+'/user/id_check',
                    data:{
                       mem_id:this.userform.mem_id,
                        pi:this.pi,
                          mins:this.mins,
                          maxs:this.maxs,
                          zerocc:this.zerocc
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
                }).then((response) =>{ 
                  this.reLoading = false
                   if(response.data.code==200)
                      {
                         
                         this.$message({
                          message:response.data.msg,
                          type: 'success'
                        });

                         
                         
                          
                      }else{
                       this.$message.error(response.data.msg)

                      }

                  }).catch((error) =>{
                     this.reLoading = false
                  })
            },
    		getVal(e){

          if(this.form.money=='')
          {
this.form.money='0';
          }

          if(e=='0')
          {
            this.form.money='0';
          }

          this.form.money=parseInt(this.form.money)+parseInt(e)
          console.log(e)
        },
    		
    	
    		
    	}
  }
</script>

 <style scoped>
 >>>.el-tabs--border-card>.el-tabs__header .el-tabs__item{
 color:#333
 }
/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }
 /deep/.typeIco .el-input__icon{
  line-height: 30px;
 }
 /deep/ .el-table__body tr.current-row>td.el-table__cell {
   
    background-color: #d3d3d3!important;
}
 .el-table__row:hover > td {
      background-color: transparent;
    }
  >>>.formItem2 label.el-form-item__label{
    color: #444 !important;
    text-align: left;
    padding-left: 5px;
    line-height: 36px;

 }
 .scroll-wrapper {
        -webkit-overflow-scrolling: touch;
        overflow: scroll;
    }
    .memlistTable .el-button--mini{
      padding:5px;margin: 0px;font-size:11px !important;
    }
 .acitonButton{
    border: none;
    padding:2px 1px !important;
   
    width:20px;

  }
  >>>.el-tabs--border-card>.el-tabs__header{
    background-color:#e4e5e6;
  }
  .infoNum{
   position: absolute;
    right: -6px;
    border-radius: 100%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 14px;
    top: 0;
   

  }
</style>



// WEBPACK FOOTER //
// src/views/management/list.vue